import { ModalBackdrop } from "./ModalBackdrop";
import { wordDiff, hasChanges } from "../lib/wordDiff";

interface GrammarReviewDialogProps {
  original: string;
  corrected: string;
  onApply: () => void;
  onClose: () => void;
  busy?: boolean;
}

export function GrammarReviewDialog({
  original,
  corrected,
  onApply,
  onClose,
  busy,
}: GrammarReviewDialogProps) {
  const chunks = wordDiff(original, corrected);
  const changed = hasChanges(chunks);

  return (
    <ModalBackdrop onClose={onClose}>
      <div className="modal modal-narrow grammar-dialog" onMouseDown={(e) => e.stopPropagation()}>
        <div className="modal-head">
          <h3 className="modal-title">Проверка грамматики</h3>
          <button type="button" className="btn-icon" onClick={onClose} aria-label="Закрыть">
            ×
          </button>
        </div>

        <div className="modal-body">
          {!changed ? (
            <div className="grammar-empty">
              Ошибок не найдено. Текст можно оставить как есть.
            </div>
          ) : (
            <>
              <div className="grammar-hint">
                <span className="grammar-legend grammar-legend--ins">зелёное</span> —
                предложенные правки,{" "}
                <span className="grammar-legend grammar-legend--del">красное</span> — что
                будет удалено.
              </div>
              <div className="grammar-diff">
                {chunks.map((c, i) => {
                  if (c.type === "equal") return <span key={i}>{c.text}</span>;
                  const className = c.type === "ins" ? "diff-ins" : "diff-del";
                  return (
                    <span key={i} className={className}>
                      {c.text}
                    </span>
                  );
                })}
              </div>
            </>
          )}
        </div>

        <div className="modal-foot">
          <div className="spacer" />
          <button type="button" className="btn-ghost" onClick={onClose} disabled={busy}>
            {changed ? "Отмена" : "Закрыть"}
          </button>
          {changed && (
            <button type="button" className="btn-primary" onClick={onApply} disabled={busy}>
              Применить
            </button>
          )}
        </div>
      </div>
    </ModalBackdrop>
  );
}
